import styled from 'styled-components';

export const StyledModalActions = styled.div<{ $justify: string }>`
  display: flex;
  justify-content: ${({ $justify }) => $justify};
  margin-top: 30px;
`;
